module.exports = __webpack_public_path__ + "img/taishan-banner.e46dcf96.jpg";